<template>
    <div>
        <div class="form-group"
             :class="{'has-warning': warning}"
        >
            <!--<div class="overlay">-->
            <!--<i class="fa fa-refresh fa-spin"></i>-->
            <!--</div>-->
            <label for="club">{{title}}</label>
            <div class="input-group ">
                <div class="input-group-btn">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                            aria-expanded="false">Trier
                        <span class="fa fa-caret-down"></span></button>
                    <ul class="dropdown-menu">
                        <li><a @click="choixTri='nom'">Trier par nom</a></li>
                        <li><a @click="choixTri='numero'">Trier par numéro</a></li>
                        <li><a @click="choixTri='province'">Trier par province</a></li>
                        <li><a @click="choixTri='discipline'">Trier par discipline</a></li>
                        <li class="divider"></li>
                        <li><a @click="choixTri='listAll'">Lister tous les clubs (non-licenciés inclus)</a></li>
                    </ul>
                </div>
                <!-- /btn-group -->
                <select class="form-control"
                        v-model="clubSelected"
                        :disabled="disabledSelect">
                    <option value="0">Choisissez un club</option>
                    <option v-show="showOptionTousLesClubs" value="-1">Tous les clubs</option>
                    <optgroup
                            v-for="(clubs, province) in provinces"
                            :label="province">
                        <option
                                v-for="club in clubs"
                                v-if="club.id!=notShowIdClub"
                                :value="club"
                        >{{club.numero_club}} {{club.club | uppercase}} {{club.tangsoodo ? '(TNG)':'' }} {{club.hapkido ? '(HPK)':'' }}
                          {{club.haedong ? '(HAE)':'' }}
                        </option>
                    </optgroup>
                </select>
            </div>
            <span class="help-block" v-if="warning">{{warningMessage}}</span>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    var _ = require('underscore')

    export default {
        data() {
            return {
                clubSelected: null,
                provinces: [],
                choixTri: 'province',
                disabledSelect: false,
            }
        },
        props: {
            clubsLicenciesUniquement: Boolean,
            reset: {
                type: Boolean,
                default: false
            },
            showOptionTousLesClubs: {
                type: Boolean,
                default: false
            },
            warning: {
                type: Boolean,
                default: false
            },
            warningMessage: {
                type: String,
                default: ""
            },
            clubPreSelected: {
                type: Number,
                default: 0
            },
            title: {
                type: String,
                default: "Club"
            },
            notShowIdClub: {
                type: Number,
                default: -2
            },
        },
        watch: {
            reset:function() {
                this.loadClubs()
            },
            choixTri: function () {
                this.loadClubs();
            },
            clubSelected: function (value) {
                this.$emit('clubSelected', value)
            },
            clubPreSelected: function () {
                this.loadClubs()
            }
        },
        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        methods: {
            findClub: function (id_club) {
                var these = this

                let clubs = _.values(this.provinces)
                var merged = [].concat.apply([], clubs);

                let clubFound = null;
                clubFound = _.find(merged, function (club) {
                    return club.id == id_club
                })
                return clubFound
            },
            loadClubs: function () {
                var these = this
                this.disabledSelect = true;

                this.$http.post(this.getRoute('getListeClubs'), {
                    "province": this.choixTri,
                    "club_to_show": this.clubPreSelected
                }).then((response) => {
                    these.provinces = response.body
                    if (these.clubPreSelected > 0 && these.clubPreSelected != null) {
                        these.clubSelected = these.findClub(these.clubPreSelected)
                    } else
                        these.clubSelected = these.clubPreSelected
                    this.disabledSelect = false;
                });
            },
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        }
        ,
        mounted: function () {
            this.choixTri = 'province';
            this.loadClubs()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Communs/listeSelectClub.vue